import { isAxiosError } from 'axios';

// Shared queryFn helper (G-14 / G-20, story 1G-10). Every module's queryFn
// that treats a 404 as "expected missing resource" MUST route through this
// helper instead of hand-rolling its own try/catch — that inline pattern is
// exactly what drifted out of sync across useSubscription/PricingPage (2-32,
// 2-54) before the shared queryFn existed for subscriptions. This is the
// generalization of that fix to every module.
//
// Resolves to `null` (never `undefined` — react-query throws "Query data
// cannot be undefined" if a queryFn resolves to undefined) when the request
// 404s; any other error/status still rejects so callers don't silently
// swallow real failures.
//
// NOTE (2-73): this is landed ahead of the sweep — useSubscription.ts still
// inlines the `=== 404` check and is migrated to call this helper in that
// follow-up story. (The other pre-existing offender, the legacy
// `ItemDetailPage`'s `report` query, was retired outright in story 5-12
// rather than migrated — the whole page it lived on is gone.)
export async function queryOrNull<T>(request: Promise<T>): Promise<T | null> {
  try {
    return await request;
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === 404) {
      return null;
    }
    throw error;
  }
}
